type PaginationProps = {
  page: number;
  setPage: (page: number) => void;
  pageCount: number;
  className?: string;
};

const Pagination = ({ page, setPage, pageCount, className }: PaginationProps) => {
  const buttonConfig = {
    prev: {
      isDisabled: page === 1,
      icon: 'm15 18l-6-6l6-6',
      text: 'Previous',
      newPage: page - 1,
      ariaLabel: 'Go to previous page',
    },
    next: {
      isDisabled: page === pageCount,
      icon: 'm9 18l6-6l-6-6',
      text: 'Next',
      newPage: page + 1,
      ariaLabel: 'Go to next page',
    },
  };

  const renderButton = (direction: 'prev' | 'next') => {
    const { isDisabled, icon, text, newPage, ariaLabel } = buttonConfig[direction];
    return (
      <button
        data-cy={`pagination-button-${direction}`}
        className='group gap-1 group flex rounded-md items-center justify-center p-0.5 text-center font-bold relative focus:z-10 focus:outline-none transition-[color,background-color,border-color,text-decoration-color,fill,stroke,box-shadow] border border-slate-300 bg-background hover:bg-slate-200 text-sm px-4 py-2 disabled:opacity-50'
        aria-label={ariaLabel}
        disabled={isDisabled}
        onClick={() => setPage(newPage)}
      >
        <span className='flex items-center gap-2'>
          <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' className='h-4 w-4'>
            <path
              fill='none'
              stroke='currentColor'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d={icon}
            ></path>
          </svg>
          {text}
        </span>
      </button>
    );
  };

  return (
    <div data-cy='pagination' className={`flex justify-center overflow-x-auto ${className ?? ''}`}>
      <div className='space-y-2 text-center'>
        <nav
          role='navigation'
          aria-label='pagination'
          className='mx-auto w-full justify-center mt-auto flex flex-col items-center'
        >
          <ul className='flex flex-row items-center gap-1.5'>
            <li>{renderButton('prev')}</li>
            <li>
              <p className='text-sm mx-2'>
                Showing
                <span data-cy='current-page-number' className='font-bold mx-1'>
                  {page}
                </span>
                of
                <span className='font-bold mx-1'>{pageCount}</span>
                pages
              </p>
            </li>
            <li>{renderButton('next')}</li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Pagination;
